import { getCookies, handleAutoDownload } from './helpers.js';

/**
 * Convert cookies object to URL-encoded string format.
 *
 * @param {Object} cookies Cookies object.
 * @return {string} URL-encoded cookies string.
 */
function formatCookiesForRequest(cookies) {
	const cookiesArray = Object.entries(cookies).map(([key, value]) => `${key}=${value}`);
	return cookiesArray.join('&');
}

/**
 * Make an AJAX request to get gated content.
 *
 * @param {Object} params Request parameters.
 * @param {string} params.ajaxUrl AJAX endpoint URL.
 * @param {number} params.postID Post ID.
 * @param {string} params.postType Post type.
 * @param {Object} params.cookies Cookies object.
 * @return {Promise<string>} Promise that resolves with the response text.
 */
async function fetchGatedContent({
	ajaxUrl, postID, postType, cookies,
}) {
	const cookiesParam = formatCookiesForRequest(cookies);
	const formData = new URLSearchParams({
		action: 'get_the_content',
		cookies: cookiesParam,
		postID: postID.toString(),
		postType,
	});

	try {
		const response = await fetch(ajaxUrl, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
			},
			body: formData.toString(),
		});

		if (!response.ok) {
			throw new Error(`HTTP error! status: ${response.status}`);
		}

		return await response.text();
	} catch (error) {
		console.warn('Error fetching gated content:', error);
		throw error;
	}
}

async function initGatedResourceDownloads() {
	// Handle auto-download if triggered.
	handleAutoDownload();

	// Legacy/page-level gated content system
	const content = document.querySelector('.gated-content');
	if (content) {
		const cookies = getCookies();

		try {
			// Fetch gated content
			const response = await fetchGatedContent({
				ajaxUrl: window.gatedContent.ajax,
				postID: window.gatedContent.postID,
				postType: window.gatedContent.postType,
				cookies,
			});

			if (response) {
				content.innerHTML = response;
			}
			content.classList.remove('hide');
		} catch (error) {
			// Error already logged in fetchGatedContent
		}
	}
}

document.addEventListener('DOMContentLoaded', initGatedResourceDownloads);
